import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseDeliveryReport() {
  const MyAxios = UseCustomAxios();

  const GetDeliveryReport = (newMyPc, bool, callback) => {
    MyAxios.get(`Admin_DeliveryReport`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetDeliveryReportByDate = (date, callback) => {
    MyAxios.get(`Admin_DeliveryReport/${date}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetDeliveryReport,
    GetDeliveryReportByDate,
  };
}
